import React from 'react';
import { useDemo } from '../../contexts/DemoContext';
import { Dialog } from './Dialog';
import { Button } from '../story/Button';
export function RestartDialog() {
  const {
    dialog,
    closeDialog,
    dispatch,
    announce
  } = useDemo();
  return <Dialog open={dialog === 'restart'} onClose={closeDialog} id="restart-demo" title="Start over?" data-id="element-465" data-mp="14ijs99ioe6r3">
      <p data-id="element-466" data-mp="zgkq22yo9fvq">This clears this visit’s story choices and tool cards. Your access settings stay.</p>
      <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end" data-id="element-467" data-mp="1edlkwfc5tqyf">
        <Button variant="secondary" onClick={closeDialog} data-id="element-468" data-mp="19fa9i067v8e3">
          Keep my visit
        </Button>
        <Button onClick={() => {
        dispatch({
          type: 'RESTART'
        });
        closeDialog();
        announce('The demo started over.');
      }} data-id="element-469" data-mp="1n66pmriyhx49">
          Start over
        </Button>
      </div>
    </Dialog>;
}